module.exports = __webpack_public_path__ + "img/1.3bd5e236.png";